import { RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';

import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { useSelector } from '~src/settings/general-settings/utils';

import { Messages } from '../../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../../commonInfra/components/FormikRadioButtonGroup';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const PERSONALIZED_RANKING_FIELD = 'settings.pulsePersonalizedRankingEnabled';
export const PERSONALIZED_INSIGHT_RANKING_SECTION_TEST_ID = 'personalized-insight-ranking-site-setting';
export const PERSONALIZED_INSIGHT_RANKING_ENABLE_BUTTON_TEST_ID = 'personalized-insight-ranking-enable';
export const PERSONALIZED_INSIGHT_RANKING_DISABLE_BUTTON_TEST_ID = 'personalized-insight-ranking-disable';

export type PersonalizedInsightRankingSectionProps = SiteSettingsForSiteAdminProps<'pulsePersonalizedRankingEnabled'>;

function getButtonsList(): RadioButtonWithLabelOption<boolean>[] {
  return [
    {
      value: true,
      label: Messages.PersonalizedRankingSiteSettingEnabled(),
      detail: Messages.PersonalizedRankingSiteSettingEnabledDescription(),
      testId: PERSONALIZED_INSIGHT_RANKING_ENABLE_BUTTON_TEST_ID
    },
    {
      value: false,
      label: Messages.PersonalizedRankingSiteSettingDisabled(),
      detail: Messages.PersonalizedRankingSiteSettingDisabledDescription(),
      testId: PERSONALIZED_INSIGHT_RANKING_DISABLE_BUTTON_TEST_ID
    }
  ];
}

export function PersonalizedInsightRankingSection(props: PersonalizedInsightRankingSectionProps) {

  const buttons = React.useMemo(() => getButtonsList(), []);

  return !useShowSettingsSection() ? null: (
    <SettingsSection title={Messages.PersonalizedRankingSiteSettingTitle()}
      testId={PERSONALIZED_INSIGHT_RANKING_SECTION_TEST_ID}
      description={Messages.PersonalizedRankingSiteSettingDescription()}>

      <FormikRadioButtonGroup
        buttonList={buttons}
        className={settingsRadioButtonItemHeight}
        name={PERSONALIZED_RANKING_FIELD}
        aria-label={Messages.PersonalizedRankingSiteSettingTitle()}
      />
    </SettingsSection>
  );
}

function useShowSettingsSection(): boolean {
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  return isOnlineEnvironment;
}

export const PersonalizedInsightRankingSectionSpecs = componentRegistryEntry({
  name: 'PersonalizedInsightRankingSection',
  component: PersonalizedInsightRankingSection
});

